
(function loginModuleDefinition() {

    'use strict';

    angular.module('LoginPage', ['ui.router', 'Config', 'Login'])
        .config([
            'configProvider', '$stateProvider',
            function loginConfig(config, $stateProvider) {


            }
        ]);
})();